/**
 * 下载工具函数的常量定义
 */

/**
 * 固定格式到小数位数的映射（基于 FORMAT_RULE_MAP）
 */
export const FORMAT_DECIMAL_MAP: Record<string, number> = {
  // 整数格式
  'int': 0,
  'Integer': 0,
  'percentInt': 0,
  'absPercentInt': 0,
  'thousandsInit': 0,
  'thousandsInteger': 0,
  'bmk': 0,
  'intBmk': 0,
  // 一位小数
  'oneDecimal': 1,
  'percent1Decimal': 1,
  'absPercent1Decimal': 1,
  'thousands1Decimal': 1,
  'bmk0': 1,
  'bm0': 1,
  'smallPercent1Decimal': 1,
  'intBmk0': 1,
  'not0IntBmk0': 1,
  // 两位小数
  'twoDecimal': 2,
  'percent2Decimal': 2,
  'absPercent2Decimal': 2,
  'thousands2Decimal': 2,
  'bmk00': 2,
  'bm00': 2,
  'small2Decimal': 2,
  'axisSmallPercent2Decimal': 2,
  'intBmk00': 2,
};

/**
 * 单词到数字的映射
 */
export const WORD_TO_DECIMAL_MAP: Record<string, number> = {
  'one': 1,
  'two': 2,
  'three': 3,
  'four': 4,
  'five': 5,
  'six': 6,
  'seven': 7,
  'eight': 8,
  'nine': 9,
  'ten': 10,
};

/**
 * Excel 默认列宽（像素）
 */
export const EXCEL_DEFAULT_COL_WIDTH = 170;

/**
 * Excel Sheet 名称最大长度（字符）
 */
export const EXCEL_SHEET_NAME_MAX_LENGTH = 31;

/**
 * Excel 默认字体大小
 */
export const EXCEL_DEFAULT_FONT_SIZE = 11;

/**
 * Excel 默认字体名称（Windows）
 */
export const EXCEL_DEFAULT_FONT_NAME_WINDOWS = '微软雅黑';

/**
 * Excel 默认字体名称（Mac）
 */
export const EXCEL_DEFAULT_FONT_NAME_MAC = '苹方-简';

/**
 * Excel 表头背景色（RGB）
 */
export const EXCEL_HEADER_BG_COLOR = '212C53';

/**
 * Excel 表头文字颜色（RGB）
 */
export const EXCEL_HEADER_TEXT_COLOR = 'FFFFFF';

